<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col class="pa-2" cols="12" md="4">
          <div class="sticky-md" style="top: 110px">
            <qr-maker />
            <!-- <v-card-actions class="justify-center">
              <div
                class="rowinfo"
                style="
                  justify-content: center !important;
                  align-items: center !important;
                "
              >
                <v-btn class="btn-download" @click="showDialog = true">
                  <v-icon>mdi-progress-download</v-icon>
                  دانلود کیوآر
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-download`"
                  :help-data="helpData"
                  :service-name="serviceName"
                  class="buttoninfo"
                  label="دانلود کیوآر"
                  style="
                    padding: unset !important;
                    align-self: center !important;
                  "
                />
              </div>
            </v-card-actions> -->
          </div>
        </v-col>

        <v-col class="pa-8" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>ورود اطلاعات</p>
                </div>
                <div v-if="qrType" class="col-md-6 mt-0 pt-0">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="visitName"
                      :disabled="e6 > 1"
                      append-icon="mdi-pen"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      label="نام کیوآر"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-visitName`"
                      :help-data="helpData"
                      :service-name="serviceName"
                      class="buttoninfo"
                      label="نام کیوآر"
                    />
                  </div>
                </div>
                <div v-if="qrType" class="col-md-6 mt-0 pt-0">
                  <div class="rowinfo">
                    <qr-address-field
                      v-model="dtUrl"
                      :disabled="e6 > 1"
                      append-icon="mdi-web"
                      class="mt-0 pt-0 contentinfo"
                      dense
                      :key="$t('qrAddressUpdate.hints.allowedChars')"
                      :hint="$t('qrAddressUpdate.hints.allowedChars')"
                      outlined
                      persistent-hint
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-dturl`"
                      :help-data="helpData"
                      :service-name="serviceName"
                      class="buttoninfo"
                      label="آدرس کیوآر"
                    />
                  </div>
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <list-expansion icon="link" mandatory single title="لینک">
                <template v-slot:content>
                  <v-row no-gutters>
                    <v-col class="pa-2">
                      <v-text-field
                        v-model="title"
                        append-icon="mdi-pencil"
                        class="rowinfo"
                        clearable
                        dense
                        label="نام لینک"
                        outlined
                        placeholder="نام لینک موردنظر خودرا وارد کنید."
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-data-link`"
                        :help-data="helpData"
                        :service-name="serviceName"
                        class="buttoninfo"
                        label="لینک"
                      />
                    </v-col>

                    <v-col class="pa-2" cols="12" md="6">
                      <v-text-field
                        v-model="data.link"
                        :rules="[urlRules.checkLink]"
                        append-icon="mdi-link"
                        class="rowinfo"
                        clearable
                        dense
                        hint="https://terminalads.com"
                        label="لینک"
                        outlined
                        placeholder="لینک موردنظر خودرا وارد کنید."
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-data-link`"
                        :help-data="helpData"
                        :service-name="serviceName"
                        class="buttoninfo"
                        label="لینک"
                      />
                    </v-col>
                  </v-row>
                </template>
              </list-expansion>

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr"
                >
                  ساخت کیوآر لینک
                </next-btn>
              </div>
            </v-stepper-content>

            <div style="visibility: hidden">
              <qr-code-make
                ref="qrCanvas"
                v-model="qrDesign"
                :file.sync="qrSvgDataUrl"
                :link="data.link"
                @save="qrDesign = $event"
              />
            </div>
          </v-stepper>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="{ title: 'دانلود کیوآر' }"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-download-Qr-d`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>

          <v-card class="pa-5">
              <download-file-with-api
              v-if="showDialog"
              :address="`${data?.domain?.name||'qrland.in/'}${data.identifier}`"
              :visit-name="visitName"
              @close="showDialog = false"
              :qr_id="data?.qrId.replace('?gateway=true','')"
              :is-qrlink="true"
            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { getLanguageCookie } from "../../../core/plugins/TitleRibbon/utils/languageCookie";
import QrCodeMake from "./qrCodeStyle/qrCodeMake.vue";
import QrMaker from "./components/qrMaker.vue";
import QrManagement from "./components/qrManage/qrManagement.vue";
import ListExpansion from "../../content/fragments/listExpansion.vue";
import NextBtn from "../../content/fragments/nextBtn.vue";
import PrevBtn from "../../content/fragments/prevBtn.vue";
import QrAddressField from "../../content/fragments/qrAddressField.vue";
import { debounce } from "../../../main";
import { mapActions } from "vuex";
import DownloadFileWithApi from "./downloadFileWithApi.vue";

export default {
  name: "qrLink",

  components: {
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrManagement,
    QrMaker,
    QrCodeMake,
    DownloadFileWithApi,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "qrLink",
      info: {},
      qrSvgDataUrl: "",
      qrType: false,
      showDialog: false,
      editable: false,
      createdId: "",
      loading: false,
      finish: false,
      dtUrl: null,
      e6: 1,
      visitName: "لینک",
      urlRules: {
        checkLink: (value) =>
          this.isURL(value) ||
          "لینک سایت باید بصورت http:// یا https:// وارد شود. ",
      },
      title: "",
      data: {
        link: "",
        shortLink: "",
        svg: "",
      },
      cons: { title: "دانلود کیوآر" },
      qrDesign: null,
    };
  },

  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;

    this.updateQr();
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
    "data.link"(val) {
      debounce(() => {
        this.updateQr();
      }, 500);
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),

    markQr(final = false) {
         if (!this.data.link || !this.isURL(this.data.link)) {
        return this.$toast.error("لینک سایت باید بصورت http:// یا https:// وارد شود.");
      }

      const trimmedId = this.data.link
        ? this.data.link.trim().replace(/https?:\/\/+/i, "")
        : "";

      this.loading = true;
      let obj = {
        type: "qrLink",
        qrType: "dynamic",
        identifier: trimmedId,
        title: this.title,
        data: JSON.stringify({
          theme: "",
          data: "",
        }),
        qr: JSON.stringify(this.qrDesign),
      };

      this.$api
        .post("/v1/testQr/store1", obj)
        .then(({ data }) => {
          this.loading = false;
          this.info = data.data;
          this.$toast.success("کیوآر لینک  شما با موفقیت ساخته شد.");
          this.setCreatedQrID(data.data.id);
          this.setQrType("qrLink");
          if (this.e6 === 1) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate();
              }, 2000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    qrUpdate() {
      this.loading = true;
      const trimmedId = this.data.link
        ? this.data.link.replace(/https?:\/\/+/i, "")
        : "";

      const data = new FormData();
      data.append("type", "qrLink");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("identifier", trimmedId);
      data.append("title", this.title);
      data.append("_method", "PUT");
      data.append("qr", JSON.stringify(this.qrDesign));
      data.append("qr_id", this.info.qrId); ///

      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: "",
        }),
      );

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then((res) => {
          this.$toast.success("کیوآر لینک شما باموفقیت ویرایش شد.");
          if (this.e6 === 1) {
            setTimeout(() => {
              this.$router.push(`/qr/list`);
              this.$refs.qrCanvas.appendCanvas(this.info.link);
            }, 500);
            setTimeout(() => {
              // this.qrUpdate();
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    updateQr() {
      setTimeout(() => {
        this.$refs.qrCanvas.appendCanvas(this.data.link);
      }, 500);
    },
    isURL(str) {
      if(!str) return false;

      //  let regex = /^(https?:\/\/)[^\s]+$/;
      //   return regex.test(str);
      try {
        const url = new URL(str);
      const res1= url.protocol === "http:" || url.protocol === "https:";
       const regex = /^(https?:\/\/)([a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})+)[^\s]*$/;
      const rest2 = regex.test(str.trim());
      return rest2 && res1;

      } catch (err) {
        return false;
      }
    },
  },
};
</script>

<style scoped></style>
